module.exports = __webpack_public_path__ + "assets/milestones-20ac74ad8dfac5cdcf7e6fea377c2e0b.png";